/* Header module
//========================================================*/

export function initHeader() {
    const HIDE_DELAY = 100;

    const $navItems  = $('.header__nav__list > .item').not('.item--english, .item--contact');
    const $dropdowns = $('.item__dropdown');

    let hideTimer   = null;
    let $activeItem = null;

    // Returns true only when the cursor has moved outside BOTH the nav item AND its dropdown
    function isOutside(relatedTarget, $item) {
        if (!relatedTarget) return true;
        const $dropdown = $item.find('> .item__dropdown');
        return (
            !$.contains($item[0], relatedTarget) &&
            $item[0] !== relatedTarget &&
            !$.contains($dropdown[0], relatedTarget) &&
            $dropdown[0] !== relatedTarget
        );
    }

    function openDropdown($item) {
        clearTimeout(hideTimer);

        if ($activeItem && $activeItem[0] !== $item[0]) {
            $activeItem.removeClass('is-open');
            $activeItem.find('> .item__dropdown').removeClass('is-open');
        }

        $activeItem = $item;
        $item.addClass('is-open');
        $item.find('> .item__dropdown').addClass('is-open');
    }

    function closeDropdown($item) {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
            $item.removeClass('is-open');
            $item.find('> .item__dropdown').removeClass('is-open');
            if ($activeItem && $activeItem[0] === $item[0]) $activeItem = null;
        }, HIDE_DELAY);
    }

    $navItems.on('mouseenter', function () {
        openDropdown($(this));
    }).on('mouseleave', function (e) {
        if (!isOutside(e.relatedTarget, $(this))) return;
        closeDropdown($(this));
    });

    $dropdowns.on('mouseleave', function (e) {
        const $item = $(this).closest('.item');
        if (!isOutside(e.relatedTarget, $item)) return;
        closeDropdown($item);
    });

    // Close on outside click
    $(document).on('click.headerDropdown', function (e) {
        if (
            !$(e.target).closest('.header__nav__list').length &&
            !$(e.target).closest('.item__dropdown').length
        ) {
            clearTimeout(hideTimer);
            $navItems.removeClass('is-open');
            $dropdowns.removeClass('is-open');
            $activeItem = null;
        }
    });
}
